<template>
  <div class="editor-container">
    <vue-cutter
      ref="cutter"
      :img="imgSrc"
      :rotate-step="1"
      :is-modal="false"
      :boxWidth="350"
      :boxHeight="300"
      :aspect-ratio="1.53"
      @change="handleChange"
      
    />
    <input type="file" @change="handleFileChange" />
    <button @click="getCroppedBlob">获取裁剪结果</button>
    <div class="footer">
      <div class="footer-content">
        <div class="footer-title">结果</div>
        <div>
          <div>总条数:{{ result.detected_regions }}</div>
          <br />
          <el-image
            style="width: 100%; height: 200px"
            :src="result.upload"
            :preview-src-list="result.upload"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCutter from 'vue-img-cutter'
  import imageService from '@/api/imageService'

export default {
  components: { VueCutter },
  data() {
    return {
      imgSrc: '',
      result: {
        url: '',
        detected_regions: 0
      }
    }
  },
  mounted() {
    debugger
    this.$nextTick(() => {
      this.screenWidth = window.innerWidth
      this.showCutter = true
    })
  },
  methods: {
    handleFileChange(e) {
      const file = e.target.files[0]
      if (file) this.imgSrc = URL.createObjectURL(file)
    },
    handleChange(data) {
      console.log('当前裁剪参数:', data)
    },
    async getCroppedBlob() {
      try {
        const blob = await this.$refs.cutter.getCroppedBlob()
        console.log('裁剪结果:', blob)
          let formData = new FormData()
          formData.append('avatar', blob, 'cropped-image.jpg')
          try {
            const response = await imageService.upload(formData)
            this.$message.success('上传成功')
            this.result = { ...response.data.data }
            console.log('上传响应：', response.data)
          } catch (error) {
            this.$message.error('上传失败')
            console.error('上传错误：', error)
          }
      
        return blob
      } catch (error) {
        console.error('裁剪出错:', error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.editor-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  ::v-deep .dialogMain {
    width: 100% !important;
  }
  .footer {
    width: 100%;
    margin-top: 20px;
    .footer-title{
      text-align:left;
    }
  }
}
</style>